/** A list of the Explore page: Steam top sellers, Steam popular new releases, GOG by popularity. */
export const EXPLORE_TABS = ['popular', 'new', 'classics'];
/** Maximum number of hero games on the store home page. */
export const MAX_STORE_HEROES = 20;
/**
 * `published`: a `new` import published its game; `version_added`: the release became a new
 * version of the game (whether or not that published it); `swapped`: a `replace` import replaced
 * the game's NZB (history only); `resolved_manually`: an admin published or deleted the game
 * while the import needed review.
 */
export const IMPORT_STATUSES = [
    'running',
    'published',
    'version_added',
    'swapped',
    'needs_review',
    'failed',
    'resolved_manually',
];
